import { render, staticRenderFns } from "./BaseCommentsAndNotes.vue?vue&type=template&id=04a5a2f4&"
import script from "./BaseCommentsAndNotes.vue?vue&type=script&lang=js&"
export * from "./BaseCommentsAndNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports